import { Component, OnInit } from '@angular/core';

import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NewsletterComponent} from '../newsletter/newsletter.component'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  date = new Date();

  constructor(private modal: NgbModal) { }

  ngOnInit() {
  }

  newsletter(){
    this.modal.open(NewsletterComponent)
  }

}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/footer/footer.component.ts